import * as React from "react";
import * as _ from "lodash";
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, CenterActionCreators, ReportActionCreators, IContractsSummaryResponse } from "@nkr/store/index";
import { ISortBy } from "@nkr/models/index";
import CenterContractGrid from "./center-contract-grid";
import { downloadFile } from '@nkr/services/download-file';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterContracts: (centerId) => Promise<IContractsSummaryResponse>,
    getCenterContractsExport: (searchValue, centerType, centerId) => Promise<IContractsSummaryResponse>,
    getVersionedFile: (centerId: number, id: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    startDate: string,
    endDate: string,
    sortBy: ISortBy[],
    contracts: any[]
}

class CenterContracts extends React.Component<TProps, IState> {


    handleFileDownload = (centerId: number, id: number) => {
        this.props.getVersionedFile(centerId, id).then(response => {
            downloadFile(response.data, `file.pdf`, response.headers.contentType);
        });
    }


    render = () => {
        return (
            <CenterContractGrid
                getCenterContracts={this.props.getCenterContracts}
                getCenterContractsExport={this.props.getCenterContractsExport}
                showLoading={this.props.showLoading}
                hideLoading={this.props.hideLoading}
                getVersionedFile={this.handleFileDownload}
            />
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getCenterContracts: (centerId) => { return dispatch(ReportActionCreators.getCenterContracts(centerId)); },
        getCenterContractsExport: (searchValue, centerType, centerId) => { return dispatch(ReportActionCreators.getCenterContractsExport(searchValue, centerType, centerId)); },
        getVersionedFile: (centerId, id) => {
            return dispatch(CenterActionCreators.getVersionedFile(centerId, id));
        },
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterContracts);